





























































import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings } from "@/shared/core/services/configService";
import store from "@/shared/core/store";
import { coursePreviewToken, coursesApi, coursePreviewRoute } from "./coursePreview";
import SubmissionVideo from "@/shared/components/videoSubmission/submissionVideo.vue";
import SubmissionPanel from "@/shared/components/videoSubmission/submissionPanel.vue";
import { VideoSubmissionState } from "@/shared/components/videoSubmission/videoSubmissionState";
import ProgramPage from "@/shared/components/programs/ProgramPage.vue";
import ProgramPanel from "@/shared/components/programs/ProgramPanel.vue";
import CzTag from "@/shared/components/cz/CzTag.vue";
import CzTitle from "@/shared/components/cz/CzTitle.vue";
import CzSegmented from "@/shared/components/cz/CzSegmented.vue";
import CzButton from "@/shared/components/cz/CzButton.vue";
import CzNotice from "@/shared/components/cz/CzNotice.vue";
import CourseLessons from "./courseLessons.vue";
import ProgramMedia from "@/shared/components/programs/ProgramMedia.vue";

@Component({ components: { SubmissionVideo, SubmissionPanel, ProgramPage, ProgramPanel, CourseLessons, ProgramMedia, CzTag, CzTitle, CzSegmented, CzButton, CzNotice } })
export default class LessonPage extends Vue {
  lesson: any = null;
  playUrl: string = "";
  progressStatus: number = 0;
  percentWatched: number = 0;
  activeTab: string = "content";

  // Course temario
  courseName: string = "";
  courseSections: any[] = [];
  courseProgress: any[] = [];
  courseTotal: number = 0;
  courseCompleted: number = 0;
  courseSequential: boolean = false;

  submissionState: VideoSubmissionState | null = null;

  // Transcription
  captionTracks: any[] = [];
  transcriptionCues: any[] = [];
  transcriptionLoading: boolean = false;
  transcriptionLoaded: boolean = false;

  private _progressTimer: any = null;

  get previewToken(): string {
    return coursePreviewToken(this.$route);
  }

  get backTo(): string {
    const path = "/courses/" + this.lesson?.courseId;
    return this.previewToken ? path + "?preview=" + encodeURIComponent(this.previewToken) : path;
  }

  get customerId(): number {
    try {
      const raw = localStorage.getItem(window.location.host + "_cc");
      if (raw) { const p = JSON.parse(raw); const v = p.value || p; return (typeof v === "string" ? JSON.parse(v) : v).id; }
    } catch (e) {}
    return 0;
  }

  get isCompleted(): boolean {
    return this.progressStatus === 2;
  }

  async mounted() {
    const lessonId = this.$route.params.lessonId;
    if (!lessonId) return;

    const crud = new CrudService();
    const data = await crud.httpGet(coursesApi(`lesson/${lessonId}`, this.previewToken));
    if (!data || !data.ok) return;

    this.lesson = data.lesson;
    this.playUrl = data.playUrl || "";
    this.captionTracks = data.captions || [];
    if (data.progress) {
      this.progressStatus = data.progress.status;
      this.percentWatched = data.progress.percentWatched;
    }
    this.loadCourse();
    if (this.previewToken) return;
    this.startProgressTracking();

    if (this.lesson.requiresSubmission) {
      const api = `${Settings.HostName}/api/public-courses`;
      this.submissionState = new VideoSubmissionState(
        { get: `${api}/submission?lessonId=${this.lesson.id}`, createVideo: `${api}/create-submission-video`, submit: `${api}/submit`, videoStatus: `${api}/video-status` },
        { lessonId: this.lesson.id },
        () => !!this.customerId
      );
      await this.submissionState.load();
    }
  }

  beforeDestroy() {
    if (this._progressTimer) clearTimeout(this._progressTimer);
    if (this.submissionState) this.submissionState.dispose();
  }

  startProgressTracking() {
    if (!this.playUrl || this.isCompleted) return;
    if (this.progressStatus === 0) {
      this.reportProgress(10);
    }
    const duration = this.lesson?.durationSeconds || 300;
    const waitMs = Math.max(duration * 0.9 * 1000, 10000);
    this._progressTimer = setTimeout(() => {
      if (!this.isCompleted) this.reportProgress(95);
    }, waitMs);
  }

  async reportProgress(percent: number) {
    const url = `${Settings.HostName}/api/public-courses/progress`;
    const data = await new CrudService().httpPost(url, {
      lessonId: this.lesson.id,
      percentWatched: percent
    });
    if (data && data.ok) {
      const wasCompleted = this.isCompleted;
      this.progressStatus = data.status;
      this.percentWatched = data.percentWatched;
      if (!wasCompleted && this.isCompleted) {
        await this.loadCourse();
      }
    }
  }

  async completeManual() {
    if (this.previewToken) return this.goToNextLesson();
    const url = `${Settings.HostName}/api/public-courses/complete-manual`;
    const data = await new CrudService().httpPost(url, {
      lessonId: this.lesson.id
    });
    if (data && data.ok) {
      this.progressStatus = 2;
      await this.loadCourse();
      this.goToNextLesson();
    }
  }

  goToNextLesson() {
    if (this.lesson.requiresSubmission) return;
    const all = this.courseSections.flatMap((s: any) => s.lessons);
    const next = all[all.findIndex((x: any) => x.id === this.lesson.id) + 1];
    if (next) this.goToLesson(next);
  }

  get tabs(): any[] {
    const tabs = [{ value: "content", label: this.$t("Content").toString() }];
    if (this.captionTracks.length > 0) tabs.push({ value: "transcription", label: this.$t("Transcription").toString() });
    if (this.lesson.requiresSubmission) tabs.push({ value: "submission", label: this.isComment ? this.$t("Your comment").toString() : this.$t("Submission").toString() });
    return tabs;
  }

  selectTab(tab: string) {
    this.activeTab = tab;
    if (tab === "transcription") this.loadTranscription();
  }

  get hasTabs(): boolean {
    return this.captionTracks.length > 0 || this.lesson.requiresSubmission;
  }

  get isComment(): boolean {
    return this.lesson && this.lesson.responseType === 1;
  }

  async loadCourse() {
    const data = await new CrudService().httpGet(coursesApi(`${this.lesson.courseId}`, this.previewToken));
    if (!data || !data.ok) return;
    this.courseName = data.course.name;
    this.courseSections = data.sections;
    this.courseProgress = data.progress || [];
    this.courseTotal = data.totalLessons;
    this.courseCompleted = data.completedLessons;
    this.courseSequential = data.course.sequentialMode;
  }

  goToLesson(l: any) {
    this.$router.push(coursePreviewRoute("/courses/" + this.lesson.courseId + "/lessons/" + l.id, this.previewToken));
  }

  seekLessonVideo(second: number) {
    if (second == null || !this.playUrl) return;
    const base = this.playUrl.replace(/[&?]t=\d+/g, "");
    this.playUrl = base + (base.includes("?") ? "&" : "?") + "t=" + second;
  }

  async loadTranscription() {
    if (this.transcriptionLoaded || this.captionTracks.length === 0) return;
    this.transcriptionLoading = true;
    const lang = this.captionTracks[0].srclang;
    const url = coursesApi(`captions/${this.lesson.id}/${lang}`, this.previewToken);
    const data = await new CrudService().httpGet(url);
    this.transcriptionLoading = false;
    this.transcriptionLoaded = true;
    if (data && data.ok && data.content) {
      this.transcriptionCues = this.parseVtt(data.content);
    }
  }

  parseVtt(vtt: string): any[] {
    const cues: any[] = [];
    const lines = vtt.split("\n");
    let i = 0;
    while (i < lines.length) {
      if (lines[i].includes("-->")) {
        const times = lines[i].split("-->");
        const start = this.parseVttTime(times[0].trim());
        i++;
        let text = "";
        while (i < lines.length && lines[i].trim() !== "") {
          text += (text ? " " : "") + lines[i].trim();
          i++;
        }
        if (text) cues.push({ start, text });
      }
      i++;
    }
    return cues;
  }

  parseVttTime(t: string): number {
    const parts = t.split(":");
    if (parts.length === 3) return +parts[0] * 3600 + +parts[1] * 60 + parseFloat(parts[2]);
    if (parts.length === 2) return +parts[0] * 60 + parseFloat(parts[1]);
    return parseFloat(t);
  }

  fmtTime(s: number): string {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return m + ":" + (sec < 10 ? "0" : "") + sec;
  }
}
